module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "fdp6xjdu",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
}
